export default{
    disponibilidad: [],
    disponibilidadAnual: [],
    dialogWidth: "1400px",
    rutaSelec: null,
    fechaSelec: null,
   
   
    pagado: 0,
    pendiente: 0,
   
   
    reservas: [],
    reservaSelec: null,
    reservasCalendario: [],
    tallerCalendario: [],

    from: null,
    until: null,
}